import { useEffect, useMemo, useState } from 'react';

import config from '@/config';
import useQuery from '@/hooks/useQuery';
import useTranslations from '@/i18n/useTranslations';
import SearchNavbarIcon from '@/shared-components/icons/components/navigation/SearchNavbarIcon';
import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

import VirtualList from './virtual-list';

export default function SearchInspiring({ userId }) {
  const t = useTranslations('common.profile.inspiring.search');
  // Estado "raw" del input (controlado) + estado "query" que dispara la búsqueda
  const [raw, setRaw] = useState('');
  const [query, setQuery] = useState({ username: '' });

  // Memoiza opciones para que su referencia sea estable entre renders
  const options = useMemo(
    () => ({
      injectToken: true,
      invalidateWhen: [`FOLLOW_ACTION_ON_${userId}`],
    }),
    [userId]
  );

  // Debounce de la búsqueda al teclear
  useEffect(() => {
    const handle = setTimeout(() => {
      setQuery({ username: raw.trim() });
    }, 300); // Cambia a 30000 para "timer" de 30s si lo deseas
    return () => clearTimeout(handle);
  }, [raw]);

  const { loading, queryData, loadMoreData } = useQuery(
    `${userId}_inspiring`,
    `${config.apis.api.url}/user/followers/${userId}`,
    query,     // objeto estable (solo cambia al cumplirse el debounce)
    options
  );

  const itemsEmpty = (queryData?.data?.data?.length ?? 0) === 0;

  return (
    <section className="search-inspiring__view">
      <div className="search-inspiring__search-field">
        <SearchNavbarIcon className="search-inspiring__search-icon" />

        <input
          type="text"
          className="search-inspiring__search-input"
          value={raw}
          onChange={(e) => setRaw(e.target.value)}
          placeholder={t('placeholder')}
          spellCheck={false}
          autoComplete="off"
        />
      </div>
      <div className="search-inspiring__results">
        {loading ? (
          <Loader className="search-inspiring__loading" thin />
        ) : itemsEmpty ? (
          query.username ? (
            <Text
              className="search-inspiring__no-results"
              paragraph>
              {t('no_results')}
            </Text>
          ) : (
            <Text className="search-inspiring__empty-message" paragraph>
              {t('empty_inspiring')}
            </Text>
          )
        ) : (
          <VirtualList
            key={queryData?.queryString || 'list'}
            items={queryData.data}
            onLoadMore={loadMoreData}
          />
        )}
      </div>
    </section>
  );
}
